import { updateBreadcrumbs } from '../../app/actions/UpdateBreadcrumbsAction';
import { appStore } from '../../app/AppStore';
import { SpotlightActionList } from '../../app/content/SpotlightActionList';
import { IMainScope } from '../../app/IMainScope';
import { ActionContext } from '../helpers/ActionContext';
import {
  ISubplaceCountsScope,
  ISubplaceTabsScope,
  SubplaceCountsHelper,
  SubplaceTabsHelper,
} from '../helpers/SubplaceCountsHelper';
import { IPlace } from '../models/IPlace';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { ISchedule } from '../ServerApi/types/ISchedule';
import { CreateScheduleAction } from '../services/CreateScheduleAction';
import { DeleteSchedulesAction } from '../services/DeleteSchedulesAction';
import { RenameAction } from '../services/RenameAction';
import { RunSchedulesAction } from '../services/RunSchedulesAction';
import { RunServerSchedulesAction } from '../services/RunServerSchedulesAction';
import { SchedulePermissions } from '../services/SchedulePermissions';
import { SetScheduleStatusAction } from '../services/SetScheduleStatusAction';
import { IScheduleViewModel } from './CreateOrEditScheduleCtrl';
import { CreateOrEditScheduleViewModelMapper } from './CreateOrEditScheduleViewModelMapper';
import { getSchedulesPlaceBreadcrumb } from './SchedulesCtrl';

export interface ISchedulePlaceScope extends IMainScope, ISubplaceCountsScope, ISubplaceTabsScope {
  schedule: ISchedule;
  scheduleViewModel: IScheduleViewModel;
  scheduleStatus: { enabled: boolean };
  scheduledActionType: string;
  rename: ($event: JQueryEventObject) => void;

  editMode: boolean;
  busy: boolean;
  beginEdit: ($event: JQueryEventObject) => void;
  cancelEdit: ($event: JQueryEventObject) => void;
  save: ($event: JQueryEventObject) => void;

  del: ($event: JQueryEventObject) => void;
  runNow: ($event: JQueryEventObject) => void;

  // Permissions
  canRunNow: () => boolean;
  canEditSchedule: () => boolean;

  objectName: string;
  SpotlightActionInfo?: SpotlightActionList.Props;
}

export class SchedulePlaceCtrl {

  public static $inject = [
    '$scope',
    '$state',
    '$translate',
    'schedule',
    'place',
    'SchedulePermissions',
    'CreateScheduleAction',
    'DeleteSchedulesAction',
    'SetScheduleStatusAction',
    'RunServerSchedulesAction',
    'RunSchedulesAction',
    'RenameAction',
    'siteId'
  ];

  constructor(
            $scope: ISchedulePlaceScope,
            $state: ng.ui.IStateService,
            $translate: ng.translate.ITranslateService,
            schedule: ISchedule,
            place: IPlace,
            SchedulePermissions: SchedulePermissions,
    private CreateScheduleAction: CreateScheduleAction,
    private DeleteSchedulesAction: DeleteSchedulesAction,
    private SetScheduleStatusAction: SetScheduleStatusAction,
    private RunServerSchedulesAction: RunServerSchedulesAction,
    private RunSchedulesAction: RunSchedulesAction,
            RenameAction: RenameAction,
            siteId: string
  ) {
    $scope.objectName = schedule.name;

    SubplaceTabsHelper.refreshWhenCurrentTabClicked($scope, $state);
    SubplaceCountsHelper.keepSubplaceCountsUpdated($scope, place);

    $scope.schedule = schedule;

    const breadcrumbs = [
      getSchedulesPlaceBreadcrumb($state),
      { text: schedule.name }
    ];

    appStore.dispatch(updateBreadcrumbs(breadcrumbs));

    // Permissions
    $scope.canRunNow = () => SchedulePermissions.canRunSchedule();
    $scope.canEditSchedule = () => SchedulePermissions.canEditSchedule();

    $scope.scheduledActionType = schedule.scheduledAction;

    $scope.rename = ($event: JQueryEventObject) => {
      RenameAction.renameSchedule(schedule, ActionContext.fromEvent($event))
        .then(() => $state.hardReload());
    };

    // Edit schedule
    $scope.beginEdit = () => {
      $scope.scheduleViewModel = CreateOrEditScheduleViewModelMapper.viewModelFromSchedule(schedule);
      $scope.editMode = true;
    };
    $scope.cancelEdit = () => $scope.editMode = false;
    $scope.save = ($event: JQueryEventObject) => {
      $scope.busy = true;
      this.CreateScheduleAction.submitScheduleUpdate($scope.scheduleViewModel, $scope.schedule.name)
        .then(() => {
          $scope.editMode = false;
          $state.hardReload();
        })
        .finally(() => $scope.busy = false);
    };

    $scope.scheduleStatus = {
      enabled: !!schedule.runNextAt
    };
    $scope.$watch('scheduleStatus.enabled', (newVal: boolean, oldVal: boolean) => {
      if (newVal !== oldVal) {
        const action = newVal
          ? this.SetScheduleStatusAction.enableSchedule(schedule)
          : this.SetScheduleStatusAction.disableSchedule(schedule);
        action.then(() => $state.hardReload());
      }
    });

    const scheduleSet = Set.singleton(schedule, (s) => s.id);

    $scope.del = ($event: JQueryEventObject) => {
      this.DeleteSchedulesAction.deleteSchedules(scheduleSet, ActionContext.fromEvent($event))
        .then(() => $state.go('^.^.schedules'));
    };

    $scope.runNow = ($event: JQueryEventObject) => {
      if(!siteId) {
        this.RunServerSchedulesAction.execute(scheduleSet, ActionContext.fromEvent($event))
          .then(() => $state.hardReload());
      } else {
        this.RunSchedulesAction.execute(scheduleSet, ActionContext.fromEvent($event))
          .then(() => $state.hardReload());
      }
    };

    // Spotlight Actions
    const runNowAction: SpotlightActionList.SpotlightActionAttributes = {
      onClick: $scope.runNow,
      iconClass: 'tb-run-now-icon',
      isAllowed: $scope.canRunNow(),
      key: 'run-now',
      testId: 'settings-action-run',
      title: $translate.instant('runNow_action')
    };

    const renameAction: SpotlightActionList.SpotlightActionAttributes = {
      onClick: $scope.rename,
      iconClass: 'tb-rename-icon',
      isAllowed: $scope.canEditSchedule(),
      key: 'setName',
      testId: 'action-rename-place',
      title: $translate.instant('rename_action')
    };


    $scope.SpotlightActionInfo = {
      actions: [runNowAction, renameAction]
    };


  }
}

Module.instance().controller('SchedulePlaceCtrl', SchedulePlaceCtrl);
